import configureStore from './configureStore';

export { configureStore };

export default this;
